<div [class.selected]="selected" [attr.style]="iconBackgroundStyle"
  class="tile full-size d-flex flex-column align-items-end bg-glass">
  <div #label class="icon-name mt-auto p-2 full-width non-selectable text-{{theme.brightContrast}}">{{name}}</div>

  <img *ngIf="authIcon && isAuthenticated" class="auth-icon non-selectable" [src]="authSuccessIcon">
  <img *ngIf="authIcon && !isAuthenticated" class="auth-icon non-selectable" [src]="authIcon">
</div>